import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Redirect, Link, withRouter } from 'react-router-dom'
import { Checkbox } from 'redux-form-material-ui'
import Paper from 'material-ui/Paper'
import Settings from 'material-ui/svg-icons/action/settings'
import RaisedButton from 'material-ui/RaisedButton'
import { Row, Col } from 'pui-react-grids'
import { makeStyles } from '../utils'
import { themeColors } from '../styles/theme'
import { accepted } from '../form/validation'
import { handleSumbissionErrors } from '../form/errors'
import { makeAuthenticatedApi } from '../api'
import Spinner from '../common/Spinner'
import { updateUser } from '../actions'

const styles = makeStyles({
  containerStyle: {
    padding: 10,
  },
  title: {
    color: themeColors.positive,
    textTransform: 'uppercase',
  },
  titleIcon: {
    fill: themeColors.positive,
    position: 'relative',
    top: 5,
    marginRight: 5,
  },
  acceptContainer: {
    display: 'inline-flex',
    marginTop: 5,
  },
  acceptLink: {
    color: themeColors.positive,
    marginLeft: 4,
  },
})

const AcceptTermsForm = reduxForm({ form: 'acceptTerms' })(({
  handleSubmit,
  invalid,
  submitting,
}) => (
  <form onSubmit={handleSubmit}>
    <Paper style={styles.containerStyle}>
      <div>
        <h3 style={styles.title}>
          <Settings style={styles.titleIcon} />Nuovi termini e condizioni
        </h3>
      </div>
      <p>
        In seguito all'aggiornamento della piattaforma sono cambiati i termini e le condizioni d'uso. L'utilizzo del Sito ne presuppone l'accettazione, in alternativa è sempre possibile recedere cancellando il proprio account.
      </p>
      <div style={styles.acceptContainer} className="ressponsive-text">
        <Field
          name="acceptTerms"
          component={Checkbox}
          validate={[accepted]}
          label="Accetto"
          style={{ width: 'none' }}
        />
        <Link to="/come-funziona#termini-condizioni" style={styles.acceptLink}>
          termini e condizioni
        </Link>
      </div>
      <div style={{ textAlign: 'center' }}>
        {!submitting
          ? <RaisedButton
              type="submit"
              disabled={invalid}
              label="Conferma"
              labelColor={themeColors.white}
              primary={true}
            />
          : <Spinner />}
      </div>
    </Paper>
  </form>
))

class AcceptTerms extends PureComponent {
  handleSubmit = () => {
    return this.props.api
      .updateUser({
        terms_accepted: 1,
      })
      .catch(handleSumbissionErrors)
  }

  handleSubmitSuccess = updateUserData => {
    this.props.updateUser(updateUserData)
  }

  render() {
    const { user, location } = this.props

    if (!user) {
      return (
        <Redirect
          to={{
            pathname: '/login',
          }}
        />
      )
    } else if (user.terms_accepted) {
      return (
        <Redirect
          to={
            location.state && location.state.referrer
              ? location.state.referrer
              : { pathname: '/' }
          }
        />
      )
    }

    return (
      <div className="padding">
        <Row>
          <Col md={3} />
          <Col md={18}>
            <AcceptTermsForm
              onSubmit={this.handleSubmit}
              onSubmitSuccess={this.handleSubmitSuccess}
            />
          </Col>
          <Col md={3} />
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  api: makeAuthenticatedApi(state),
  user: state.auth.user,
})

export default withRouter(
  connect(mapStateToProps, {
    updateUser,
  })(AcceptTerms)
)



// WEBPACK FOOTER //
// ./src/pages/AcceptTerms.js